module.exports = __webpack_public_path__ + "static/media/EBSCO_logo.5147f712.svg";